import { map } from '.'

/**
 * update - update deeply nested state paths
 *   - state: The state to update
 *   - path: An array or pathstring of the path to update
 *   - value: The new value
 *
 * Examples:
 *   const state = { foo: { 1: { key: "val" }, 2: { key: "val" } } }
 *   update(state, ["foo", 1, "key"], "updated") //=> { foo: { 1: { key: "updated" }, 2: { key: "val" } } }
 *   update(state, "foo[2].key", "updated") //=> { foo: { 1: { key: "val" }, 2: { key: "updated" } } }
 *
 */
export const update = (state, path, value, i = 0) => {
  path = Array.isArray(path)
    ? path.map((x) => (x == null ? x : x.toString()))
    : // eslint-disable-next-line
      path.split(/\.|[\[.*\]|^\]]/g).filter((x) => x !== '')
  const field = path[i]
  return Array.isArray(state)
    ? map(state, (v, j) => (j.toString() === field ? (path[i + 1] ? update(v, path, value, i + 1) : value) : v))
    : {
        ...state,
        [field]: path[i + 1] ? update(state[field], path, value, i + 1) : value,
      }
}
